<template>
  <v-form ref="supportTicketForm" lazy-validation>
    <v-row dense>
      <v-col md="12">
        <v-radio-group
          class="mt-2"
          v-model="ticket.type"
          row
          dense
        >
          <v-radio
            label="For Driver"
            value="driver"
          ></v-radio>
          <v-radio
            label="For Customer"
            value="customer"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col md="12">
        <v-textarea
          outlined
          v-model="ticket.text"
          rows="5"
          :label="'Message'"
          :rules="requiredRule"
        ></v-textarea>
      </v-col>
     
      <v-col md="12" class="text-center">
        <v-btn
          @click="createSupportTicket"
          elevation="0"
          :ripple="false"
          small
          class="
            font-weight-bold
            text-capitalize
            btn-ls btn-primary
            bg-gradient-primary
            py-3
            px-6
          "
        >Create Support Ticket</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "BookingSupportTicketForm",
  props: {
    booking: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      requiredRule: [(v) => !!v || "Message is required",
        (v) => (v && v.length >= 20) || "Message is too small",
      ],
      ticket: {
        text: '',
        type: "driver",
        bookingId: ''
      }
    }
  },
  methods: {
    createSupportTicket() {
      if (this.$refs.supportTicketForm.validate()) {
        this.ticket.bookingId = this.booking.id
        this.$store.dispatch('booking/createSupportTicket', this.ticket).then(response => {
          if (response.error == 'no_error') {
            console.log('ticket response', response)
            this.$refs.supportTicketForm.reset()
            this.$snackbar.success('Support ticket created.')
            this.$emit('close')
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>